if (!customElements.get('product-bundling')) {
  class ProductBundling extends HTMLElement {
    constructor() {
      super();

      this.addAllButton = this.querySelector('.add-all-to-cart');
      this.mainProdVariantSelected = this.parentElement.querySelector('buy-buttons.buy-buttons-row.main-product .form.js-product-form input[name="id"]');
      this.bundleProducts = this.querySelectorAll('product-bundle-form .form.js-product-form input[name="id"]');
      // Get variant IDs from data attribute
      const variantIdsString = this.dataset.variantIds || '';
      this.variantIds = variantIdsString.split(',').filter(id => id.trim() !== '');
      this.variantIds.unshift(this.mainProdVariantSelected.value);
      
      this.isAddingToCart = false;
    }

    connectedCallback() {
      if (this.addAllButton) {
        this.addAllButton.addEventListener('click', this.handleAddAllToCart.bind(this));
      } else {
        console.error('Add all button not found in the component');
      }
      
      this.mainProdVariantSelected.addEventListener('change', () => {
        this.handleMainProductVariantChange();
      });
      this.handleVariantChange();
    }

    handleMainProductVariantChange() {
      let varMainNewProductId = this.mainProdVariantSelected.value;
      let storedMainVariantId = this.variantIds[0];
      if (varMainNewProductId != storedMainVariantId) {
        this.variantIds[0] = varMainNewProductId;
      }
    }

    handleVariantChange() {
      this.bundleProducts.forEach((product, index) => {
        if (product) {
          product.addEventListener('change', () => {
            let varProductId = product.value;
            let storedVariantId = this.variantIds[index + 1];
            if (varProductId != storedVariantId) {
              this.variantIds[index + 1] = varProductId;
            }
          });
        }
      });
    }

    async handleAddAllToCart(event) {
      event.preventDefault();
      if (this.isAddingToCart || this.variantIds.length === 0) return;
      this.isAddingToCart = true;
      
      const originalText = this.addAllButton.textContent;
      this.addAllButton.textContent = 'Adding...';
      this.addAllButton.disabled = true;
      
      try {
        for (const variantId of this.variantIds) {
          
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: parseInt(variantId, 10),
                quantity: 1
              }]
            })
          });
          
          if (!response.ok) {
            const errorData = await response.json();
            console.error('Error response from cart/add.js:', errorData);
            throw new Error(errorData.description || 'Error adding item to cart');
          }
        }
        
        // Dispatch event to notify cart changes
        document.dispatchEvent(
          new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
        );
        
        // Open cart drawer if it exists
        const cartDrawer = document.querySelector('.js-cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          // Redirect to cart page if no drawer
          console.log('No cart drawer found, redirecting to cart page');
          window.location.href = '/cart';
        }
        
        // Show added notification if component exists
        this.showAddedNotification();
      } catch (error) {
        console.error('Error adding bundle products to cart:', error);
        // Show error message
        this.showErrorMessage(error.message);
      } finally {
        // Reset button state
        this.addAllButton.textContent = originalText;
        this.addAllButton.disabled = false;
        this.isAddingToCart = false;
      }
    }
    
    showAddedNotification() {
      if (customElements.get('added-notification')) {
        const notification = document.createElement('added-notification');
        notification.classList.add('added-notification', 'added-notification--hidden');
        notification.dataset.productTitle = 'Bundle items';
        notification.innerHTML = `
          <div class="added-notification__message">
            <div class="added-notification__message-inner">
              <div class="added-notification__message-text">
                <span class="added-notification__message-title"></span> added to cart.
                <a href="/cart">View cart</a>
              </div>
            </div>
            <button class="added-notification__close">&times;</button>
          </div>
        `;
        document.body.appendChild(notification);
      }
    }
    
    showErrorMessage(message = '') {
      const errorMsg = message || 'There was an error adding the bundle to your cart. Please try again.';
      alert(errorMsg);
    }
  }

  customElements.define('product-bundling', ProductBundling);
  console.log('product-bundling custom element defined');
} else {
  console.log('product-bundling already defined');
}

const ProductBundleForm = class extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('.js-product-form');
    if (this.form) {
      const idInput = this.form.querySelector('[name="id"]');
      idInput.disabled = false;
      idInput.required = true;

      if (theme.settings.afterAddToCart !== 'no-js') {
        this.submitBtn = this.querySelector('[name="add"]');
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }
    }
  }

  /**
   * Handles submission of the product form.
   * @param {object} evt - Event object.
   */
  async handleSubmit(evt) {
    evt.preventDefault();
    if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

    this.setErrorMsgState();

    const formValid = this.validate();
    if (!formValid) return;

    // Disable "Add to Cart" button until submission is complete.
    this.submitBtn.setAttribute('aria-disabled', 'true');
    this.submitBtn.classList.add('is-loading');

    const formData = new FormData(this.form);
    const sectionsToUpdate = ['page-header', 'cart-drawer'].map((sel) => document.querySelector(sel)).filter((el) => el);
    const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);

    formData.append('sections_url', window.location.pathname);
    formData.append('sections', sectionIds.join(','));

    const fetchRequestOpts = {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    };

    try {
      const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
      const data = await response.json();
      let error = typeof data.description === 'string' ? data.description : data.message;
      if (data.errors && typeof data.errors === 'object') {
        error = Object.entries(data.errors).map((item) => item[1].join(', '));
      }
      if (data.status) this.setErrorMsgState(error);
      if (!response.ok) throw new Error(response.status);

      if (document.querySelector('.template-cart')) {
        // Cart page
        const cartForm = document.querySelector('cart-form');
        if (cartForm && cartForm.enableAjaxUpdate) {
          cartForm.refresh();
        }
      } else if (theme.settings.afterAddToCart === 'page') {
        // Allow the tick animation to complete
        setTimeout(() => {
          window.location.href = theme.routes.cart;
        }, 300);
      } else {
        sectionsToUpdate.forEach((el) => {
          el.updateFromCartChange(data.sections[el.dataset.sectionId]);
        });

        if (theme.settings.afterAddToCart === 'notification') {
          const notification = document.getElementById('AddedNotification').content.firstElementChild.cloneNode(true);
          notification.dataset.productTitle = data.product_title;
          let notificationContainer = document.querySelector('.pageheader--sticky');
          if (!notificationContainer) {
            notificationContainer = document.querySelector('body');
          }
          notificationContainer.appendChild(notification);
        } else if (theme.settings.afterAddToCart === 'drawer') {
          document.querySelector('.js-cart-drawer').open();
        }
      }

      this.dispatchEvent(new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: {
          variantId: data.variant_id
        }
      }));

      // Re-enable 'Add to Cart' button.
      this.submitBtn.classList.add('is-success');
      this.submitBtn.removeAttribute('aria-disabled');
      setTimeout(() => {
        this.submitBtn.classList.remove('is-loading');
        this.submitBtn.classList.remove('is-success');
      }, 2000);
    } catch (error) {
      console.log(error); // eslint-disable-line
      this.dispatchEvent(new CustomEvent('on:cart:error', {
        bubbles: true,
        detail: {
          error: this.errorMsg.textContent
        }
      }));

      // Re-enable 'Add to Cart' button.
      this.submitBtn.classList.remove('is-loading');
      this.submitBtn.classList.remove('is-success');
      this.submitBtn.removeAttribute('aria-disabled');
    }
  }

  /**
   * Shows/hides an error message.
   * @param {string} [error=false] - Error to show a message for.
   */
  setErrorMsgState(error = false) {
    this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
    if (!this.errorMsg) return;

    this.errorMsg.hidden = !error;
    if (error) {
      this.errorMsg.innerHTML = '';
      const errorArray = Array.isArray(error) ? error : [error];
      errorArray.forEach((err, index) => {
        if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
        this.errorMsg.insertAdjacentText('beforeend', err);
      });
    }
  }

  /**
   * Validate form & show errors.
   * @returns {boolean} - Is form valid.
   */
  validate() {
    let isValid = true;
    this.querySelectorAll('variant-picker .option-selector').forEach((el) => {
      if (el.dataset.selectorType === 'listed') {
        const input = el.querySelector('input');
        const inputIsValid = input.reportValidity();
        if (!inputIsValid) {
          isValid = false;
        }
      } else {
        // Clear prior errors
        el.querySelectorAll('.label__prefix').forEach((label) => label.remove());
        el.querySelectorAll('.label--contains-error').forEach((label) => label.classList.remove('label--contains-error'));

        const selectedOption = el.querySelector('.custom-select .js-option[aria-selected="true"]');
        if (!selectedOption) {
          const label = el.querySelector('.label');
          if (label) {
            label.setAttribute('aria-live', 'polite');
            label.classList.add('label--contains-error');
            const labelPrefix = document.createElement('span');
            labelPrefix.innerText = `${theme.strings.productsProductChooseA} `;
            labelPrefix.className = 'label__prefix';
            label.prepend(labelPrefix);
            if (el && el.getBoundingClientRect) {
              theme.scrollToRevealElement(el);
            }
          }
          isValid = false;
        }
      }
    });

    return isValid;
  }
};

window.customElements.define('product-bundle-form', ProductBundleForm);
